import React from 'react';

import propTypes from 'prop-types';

import { Text, TextType } from 'ui-components/components/text';

import { emptyCustomsItem } from '../../../../../services/customs-service';

import style from './customs-information.module.less';

const emptyItem = emptyCustomsItem();

const CustomsItemsCount = ({
  customsItemsLength,
  description = emptyItem.description,
  fulfillmentPlanItemId = emptyItem.fulfillmentPlanItemId,
  harmonizedTariffCode = emptyItem.harmonizedTariffCode,
  unitPrice = emptyItem.unitPrice.value,
}) => {
  const customsItemsCount = () => {
    if (
      customsItemsLength === 1 &&
      description === emptyItem.description &&
      unitPrice === 0 &&
      harmonizedTariffCode === emptyItem.harmonizedTariffCode &&
      fulfillmentPlanItemId === emptyItem.fulfillmentPlanItemId
    ) {
      return 0;
    }
    return customsItemsLength;
  };

  const value = customsItemsCount();

  return <Text className={style['customs-information-summary-data']} element='span' textType={TextType.Label} value={value} />;
};

CustomsItemsCount.propTypes = {
  customsItemsLength: propTypes.number.isRequired,
  description: propTypes.string,
  fulfillmentPlanItemId: propTypes.string,
  harmonizedTariffCode: propTypes.string,
  unitPrice: propTypes.number,
};

export default React.memo(CustomsItemsCount);
